import React from 'react';
import { dehydrate, QueryClient } from '@tanstack/react-query';
import { ArrowLeftIcon } from 'icons';
import { GetStaticProps } from 'next';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { BlokMainCards, MainSubjects, RequiredSubjects } from 'modules/blok-test';
import {
  getLanguage,
  getSubjectsName,
  getThereDirection,
  globalConst,
  useLanguage,
  useThereDirection
} from 'modules/global';

import { NextHead } from 'components';

const Index = () => {
  const t = useTranslations();
  const { language, isLoading: isLanguageLoading } = useLanguage();
  const { thereDirection, isLoading: isDirectionLoading } = useThereDirection();

  return (
    <>
      <NextHead title={t('meta.virtual.title')} description={t('meta.virtual.description')} />

      <div className="mx-auto max-w-[1000px] p-0 sm:my-7 sm:p-4 pb-20">
        <Link href={globalConst.pageNames.BLOCK_TEST}>
          <div className="m-4 inline-flex cursor-pointer items-center justify-start gap-2 font-semibold sm:m-0">
            <ArrowLeftIcon /> {t('common.ortga_qaytish')}
          </div>
        </Link>
        <div className="grid grid-cols-1 gap-4 sm:mt-5 sm:grid-cols-2 md:grid-cols-3">
          <div className="hidden self-start md:sticky md:top-4 md:block">
            <BlokMainCards
              color="text-gray-800"
              bgColor="bg-red-200"
              image="/images/vertual-bg.webp"
              text={t('home.banner.Virtualtest')}
            />
          </div>
          <div className="col-span-2 space-y-4">
            <div>
              <RequiredSubjects />
            </div>
            <MainSubjects
              componentFor="virtual"
              languageData={language?.languages}
              languageLoading={isLanguageLoading}
              directionLoading={isDirectionLoading}
              directionData={thereDirection?.directions}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Index;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const queryClient = new QueryClient();

  await Promise.allSettled([
    queryClient.prefetchQuery({
      queryKey: [globalConst.queryKeys.GET_THERE_DIRECTION],
      queryFn: getThereDirection
    }),
    queryClient.prefetchQuery({
      queryKey: [globalConst.queryKeys.GET_LANGUAGE],
      queryFn: getLanguage
    }),
    queryClient.prefetchQuery({
      queryKey: [globalConst.queryKeys.SUBJECTS_NAME],
      queryFn: getSubjectsName
    })
  ]);

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
      messages: (await import(`../../messages/${locale}.json`)).default
    }
  };
};
